import {validateMobileNumber} from "./mobileValidation";

function msieversion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
  {
    return true;
  }
  else
  {
    return false;
  }
}

function checkConfirmField(field) {
  const conf = field.data('confirm');
  const value = field.val().trim();
  const expected = $(conf).val().trim();
  if(value.length > 0) {
    if (value === expected) {
      $(field).removeClass('has-error').addClass('is-ok');
      $(field).parent().find('p').hide();
      return true;
    }
    $(field).removeClass('is-ok').addClass('has-error');
    $(field).parent().find('p').show();
    return false;
  }
  return true;
}

let onErrorAnimate = null;

function checkItemValidity(item) {
  let errorBox = null;
  if ($(item).data('for')) {
    errorBox = $($(item).data('for'));
  } else {
    errorBox = $(item).next('p');
    if (!errorBox.hasClass('error')) {
      errorBox = null;
    }
  }

  if(!$(item).hasClass("live-phone-format") && ($(item).is('input') || $(item).is('select') || $(item).is('textarea'))) {
    if($(item).is(':visible')) {
      if ($(item).hasClass('email-conditional-parent')) {
        if ($(item).val()) {
          const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!re.test($(item).val())) {
            $(item).addClass('has-error').removeClass('is-ok');

            if (errorBox) {
              let message = 'Please enter a valid email address.';
              errorBox.html(message).show();
            }
            return false;
          } else {
            $(item).addClass('is-ok').removeClass('has-error');

            if (errorBox) {
              errorBox.hide();
            }
            return true;

          }
        } else {
          $(item).removeClass('is-ok').removeClass('has-error');

          if (errorBox) {
            errorBox.hide();
          }
          return true;
        }
      } else {
        if ($(item).is('input')) {
          $(item).val($(item).val().trimStart().trimEnd());
        }
        if (!item.checkValidity()) {
          $(item).addClass('has-error').removeClass('is-ok');
          if (errorBox) {
            let message = item.validationMessage;
            if (item.validity.patternMismatch) {
              if (`${item.title}` == ""){
                message = $(item).data('title');
              } else {
                message = `${item.title}`;
              }
            }
            errorBox.html(message).show();
          }
          return false;
        }
      }
    } else {
      $(item).removeClass('validate').removeClass('is-ok').removeClass('has-error');
      return true;
    }
  } else if ($(item).hasClass("live-phone-format")) {
    return validateMobileNumber(item);
  } else {
    return true;
  }
  if($('.dob-day').length) {
    if ($(item).hasClass('dob-day') || $(item).hasClass('d-o-b-month') || $(item).hasClass('d-o-b-year')) {
        const dobCheck = $('.dob-day, .d-o-b-month, .d-o-b-year');

      let dobDay = parseInt($('.dob-day').val());
      let dobMonth = parseInt($('.d-o-b-month').val());
      let dobYear = parseInt($('.d-o-b-year').val());

      if (dobDay > 0 && dobMonth > 0 && dobYear > 0) {
        if (new Date(dobYear + 18, dobMonth - 1, dobDay) > new Date()) {

          $('.dob-day').removeClass('is-ok').addClass('has-error');
          if($('.dob-day').val()) {
            $('.dob-day').next('p').hide();
          }

          $('.d-o-b-month').removeClass('is-ok').addClass('has-error');
          if($('.d-o-b-month').val()) {
            $('.d-o-b-month').next('p').hide();
          }

          $('.d-o-b-year').removeClass('is-ok').addClass('has-error');
          if($('.d-o-b-year').val()) {
            $('.d-o-b-year').next('p').hide();
          }

          let message = 'You cannot register if you are under 18 years old.';
          $('.error-dob').html(message).show();

          return false;
        } else {
          $('.error-dob').html('').hide();
          $('.dob-day').removeClass('has-error').addClass('is-ok');
          $('.d-o-b-month').removeClass('has-error').addClass('is-ok');
          $('.d-o-b-year').removeClass('has-error').addClass('is-ok');
        }
      }
    }
  }
  if (errorBox) {
    if(!$(item).hasClass('conditional-tin-validate') && !$(item).hasClass('bvn-group') && !$(item).hasClass('acc-num-group')) {
      errorBox.html('').hide();
    } else {
      if($(item).hasClass('bvn-group')) {
        let bvnGroupState = true;
        $('.bvn-group').each(function() {
          if($(this).hasClass('has-error')) {
            bvnGroupState = false;
          }
        });

        if(bvnGroupState === true) {
          errorBox.html('').hide();
        }
      }

      if($(item).hasClass('acc-num-group')) {
        let accGroupState = true;
        $('.acc-num-group').each(function() {
          if($(this).hasClass('has-error')) {
            accGroupState = false;
          }
        });

        if(accGroupState === true) {
          errorBox.html('').hide();
        }
      }

    }
  }
  if($(item).prop('required') != true) {
    if($(item).val().length > 0) {
      $(item).removeClass('has-error').addClass('is-ok');
    } else {
      $(item).removeClass('has-error').removeClass('is-ok');
    }
  } else {
    $(item).removeClass('has-error').addClass('is-ok');
  }

  if($(item).hasClass('custom-placeholder')) {
    if($(item).hasClass('is-ok')) {
      $(item).parent().addClass('form-label-group');
      let customClass = '';
      if($(item).parent().hasClass('flex-group--item')) {
        customClass += ' custom-placeholder';
      }
      if($(item).parent().hasClass('force-left')) {
        customClass += ' custom-placeholder';
      }
      if($(item).hasClass('ie-placeholder')) {
        customClass += ' ie-placeholder';
      }
      if($(item).parent().find('label')) {
        $(item).parent().find('label').remove();
      }
      $(item).parent().append('<label class="' + customClass + '">' + $(item).data('placeholder-label') + '</label>');
    } else {
      $(item).parent().removeClass('form-label-group');
      $(item).parent().find('label').remove();
    }
  }


  return true;
}

window.checkItemValidity = checkItemValidity;

function checkFormValidity(form) {
  let valid = true;

  const customValidation = $(form).find('.form-confirm:visible');
  customValidation.each(function () {
    valid = checkConfirmField($(this)) && valid;
  });


  form.find('.validate').each(function () {
    const item = $(this).get(0);
    if($(item).hasClass('has-error') && $(item).hasClass('conditional-validate')) {
      valid = true && valid;
    } else {
      valid = checkItemValidity(item) && valid;
    }
  });
  form.find('.js-phone-valid').each(function () {
    const pattern = $(this).data('pattern');
    const prefix = $($(this).data('prefix'));
    if (pattern && prefix) {
      const phoneNum = (prefix.val() + $(this).val()).replace(/\s/g, '');
      const regex = new RegExp(pattern);
      valid = regex.test(phoneNum) && valid;
      $(this).trigger('change');
    }
  });
  if(valid == true) {
    form.find('.conditional-validate').each(function () {
      const item = $(this).get(0);
      if($(item).hasClass('has-error') && $(item).hasClass('conditional-validate')) {
        $(item).val('');
      }
    });
  } else {
    if(form.find('.has-error:visible').first().length) {
      clearTimeout(onErrorAnimate);
      onErrorAnimate = setTimeout(function() {
        if(form.find('.has-error:visible').first().length) {
          if ($('html, body').scrollTop() != ($(form.find('.has-error:visible').first()).offset().top - 85)) {
            $('html, body').animate({
              scrollTop: ($(form.find('.has-error:visible').first()).offset().top - 85)
            }, 300);
          }
        } else {
          form.find('p.error:visible').hide();
        }
      }, 200);
    } else {
      form.find('p.error:visible').hide();
    }
  }
  return valid;
}

window.checkFormValidity = checkFormValidity;

function onFieldInvalidOrBlur(item) {
  item.off('invalid');
  checkItemValidity(item.get(0));
  item.on('invalid', () => {
    onFieldInvalidOrBlur(item);
  });
}

function onPhoneFieldsInvalidOrBlue(item) {
  let errorBox = null;
  if (item.data('for')) {
    errorBox = $(item.data('for'));
  } else {
    errorBox = item.next('p');
    if (!errorBox.hasClass('error')) {
      errorBox = null;
    }
  }
  const pattern = item.data('pattern');
  const prefix = $(item.data('prefix'));
  if (pattern && prefix) {
    const phoneNum = (prefix.val() + item.val()).replace(/\s/g, '');
    const regex = new RegExp(pattern);
    if (!regex.test(phoneNum)) {
      item.addClass('has-error').removeClass('is-ok');
      if (errorBox) {
        errorBox.html('Sorry incorrect number, please check and try again').show();
      }
      return false;
    }
    item.removeClass('has-error').addClass('is-ok');
    if (errorBox) {
      errorBox.html('').show();
    }
  }
  return false;
}

export default function validation() {
  $('form.js-validate input[type=submit]').on('click', function (event) {
    const valid = checkFormValidity($(this).closest('form'));
    if (!valid) {
      event.preventDefault();
      event.stopPropagation();
    }
  });

  $('form.js-validate').on('submit', function (event) {
    const form = $(this);
    const valid = checkFormValidity(form);

    if (valid) {
      return true;
    }
    event.stopPropagation();
    return false;
  });

  $('.validate').on('change blur invalid', function (event) {
    /*
     * @todo
     * Repair ugly hack - the problem is built-in 'checkValidity' method is
     * firing the 'invalid' event and there is an event loop
     */
    event.preventDefault();
    if ($(this).hasClass('js-phone-valid')) {
      onPhoneFieldsInvalidOrBlue($(this));
    }
    onFieldInvalidOrBlur($(this));
    return false;
  });

  $('.validate:not([type=radio])').each(function () {
    const val = $(this).val();
    if (val) {
      checkItemValidity(this);
    }
  });

  // for fields which need confirmation like Memorable word or email-address
  $('.form-confirm').on('keyup change focusout', function(e) {
    checkConfirmField($(this));
  });

  $('.form-confirm-check').on('keyup change focusout', function(e) {
    $('.form-confirm').trigger('focusout');
  });

  $('form').submit(function () {
    const customValidation = $(this).find('.form-confirm:visible');
    let valid = true;
    customValidation.each(function () {
      valid = valid && checkConfirmField($(this));
    });
    return !!valid;
  });

  $('.conditional-validate').on('keyup', function(e) {
    if($(this).val().length > 0) {
      $(this).addClass('validate').prop('required',false);

        const item = $(this).get(0);
        let errorBox = null;
        if ($(item).data('for')) {
          errorBox = $($(item).data('for'));
        } else {
          errorBox = $(item).next('p');
          if (!errorBox.hasClass('error')) {
            errorBox = null;
          }
        }
        if (!item.checkValidity()) {
          $(item).addClass('has-error').removeClass('is-ok');

          if (errorBox) {
            let message = item.validationMessage;
            if (item.validity.patternMismatch) {
              message = `${item.title}`;
            }
            if($(item).data('conditional-validate-msg')) {
              message += `<br/>\n${$(item).data('conditional-validate-msg')}`;
            }
            errorBox.html(message).show();
          }
          return false;
        }
        if (errorBox) {
          errorBox.html('').hide();
        }
        $(item).removeClass('has-error').addClass('is-ok');
        return true;

    } else {
      $(this).removeClass('validate').prop('required',false);
      if($(this).hasClass('has-error')) {
        $(this).removeClass('has-error');
        $(this).parent().find('p.error').css('display','none');
      }
    }
  });


  $('.conditional-tin-validate').on('keyup blur change', function(e) {
    let isTin = false;
    let isAllTin = true;
    $('.conditional-tin-validate').each(function() {
      if($(this).val().length > 0) {
        isTin = true;
      }
    });

    if(isTin == true) {
      $('.conditional-tin-validate').addClass('validate').prop('required',true);


        $('.conditional-tin-validate').each(function() {
            const item = $(this).get(0);
            let errorBox = null;
            if ($(item).data('for')) {
              errorBox = $($(item).data('for'));
            } else {
              errorBox = $(item).next('p');
              if (!errorBox.hasClass('error')) {
                errorBox = null;
              }
            }
            if (!item.checkValidity()) {
              $(item).addClass('has-error').removeClass('is-ok');

              if (errorBox) {
                let message = item.validationMessage;
                if (item.validity.patternMismatch) {
                  message += `<br/>\n${item.title}`;
                }
                if($(item).data('conditional-validate-msg')) {
                  message += `<br/>\n${$(item).data('conditional-validate-msg')}`;
                }
                errorBox.html(message).show();
              }
              isAllTin = false;
            } else {
              $(item).removeClass('has-error').addClass('is-ok');
            }
        });

        if(isAllTin == true) {
          $(this).parent().parent().find('p.error').css('display','none');
        }
    } else {
      $('.conditional-tin-validate').removeClass('validate').removeClass('has-error').prop('required',false);
      $(this).parent().parent().find('p.error').css('display','none');

    }
  });

  $(document).on('change', 'select.custom-placeholder', function(e) {
    if (!$(this).hasClass('validate') || $(this).hasClass('state')) {
      if ($(this).val()) {
        $(this).parent().addClass('form-label-group');
        let customClass = '';
        if ($(this).parent().hasClass('flex-group--item')) {
          customClass = 'custom-placeholder';
        }
        if ($(this).parent().hasClass('force-left')) {
          customClass = 'custom-placeholder';
        }
        if ($(this).parent().find('label')) {
          $(this).parent().find('label').remove();
        }
        $(this).parent().append('<label class="' + customClass + '">' + $(this).data('placeholder-label') + '</label>');
        $(this).addClass('is-ok');
      } else {
        $(this).parent().removeClass('form-label-group');
        $(this).parent().find('label').remove();
        $(this).removeClass('is-ok');
      }
    }
  });

  $('select.custom-placeholder').each(function(i,obj) {
      if ($(obj).val()) {
        $(obj).parent().addClass('form-label-group');
        let customClass = '';
        if ($(obj).parent().hasClass('flex-group--item')) {
          customClass = 'custom-placeholder';
        }
        if ($(obj).parent().hasClass('force-left')) {
          customClass = 'custom-placeholder';
        }
        if ($(obj).parent().find('label')) {
          $(obj).parent().find('label').remove();
        }
        $(obj).parent().append('<label class="' + customClass + '">' + $(obj).data('placeholder-label') + '</label>');
        $(obj).addClass('is-ok');
      } else {
        $(obj).parent().removeClass('form-label-group');
        $(obj).parent().find('label').remove();
        $(obj).removeClass('is-ok');
      }
  });

  if(msieversion() == true) {
    $('input[type=text], input[type=tel], input[type=email]').on('keyup', function (e) {
      if ($(this).val()) {
        $(this).parent().find('label').addClass('ie-placeholder');
        $(this).addClass('ie-placeholder');
      } else {
        $(this).parent().find('label').removeClass('ie-placeholder');
        $(this).removeClass('ie-placeholder');
      }
    });
    $('select').on('change', function (e) {
      if ($(this).val()) {
        $(this).parent().find('label').addClass('ie-placeholder');
        $(this).addClass('ie-placeholder');
      } else {
        $(this).parent().find('label').removeClass('ie-placeholder');
        $(this).removeClass('ie-placeholder');
      }
    });
  }

}
